// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor-container {
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    transition: border 0.2s ease;
    width: 100% !important;
}

.text-editor-container.has-error {
    border: 1px solid #d32f2f;
}

.text-editor-container.disabled .ql-editor {
    background-color: #f5f5f5;
    color: #999;
}

.text-editor-container .ql-editor {
    min-height: 200px;
    padding: 12px;
    font-size: 16px;
}

.editor-text {

    font-size: 0.875rem;
    margin-top: 4px;
    margin-left: 8px;

    &.error {
        color: #d32f2f;
    }

}

.editor-char-count {
    font-size: 0.875rem;
    margin-top: 4px;
    margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TextEditor/TextEditor.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;;IAEhB;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".text-editor-container {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    overflow: hidden;\n    transition: border 0.2s ease;\n    width: 100% !important;\n}\n\n.text-editor-container.has-error {\n    border: 1px solid #d32f2f;\n}\n\n.text-editor-container.disabled .ql-editor {\n    background-color: #f5f5f5;\n    color: #999;\n}\n\n.text-editor-container .ql-editor {\n    min-height: 200px;\n    padding: 12px;\n    font-size: 16px;\n}\n\n.editor-text {\n\n    font-size: 0.875rem;\n    margin-top: 4px;\n    margin-left: 8px;\n\n    &.error {\n        color: #d32f2f;\n    }\n\n}\n\n.editor-char-count {\n    font-size: 0.875rem;\n    margin-top: 4px;\n    margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
